const axios = require("axios");

class NetworkHandler {
    constructor(component) {
        this.component = component;
        this.state = component.$store.state;
    }

    requestData() {
        axios
            .get(this.state.serverURL + "/getProjectData", { withCredentials: true })
            .then((response) => {
            })
            .catch((e) => console.log(e)
            );
        axios
            .post(this.state.serverURL + "/users", {}, { withCredentials: true })
            .then((response) => {
            })
            .catch((e) => console.log(e)
            );
    }

    async pressedRequest(events, automationMethod, visualise) {
        var simulator = this.state.simulator;
        
        if(simulator.hoursPassed != 0){
            console.error("Only available for the first hour");
        }
        //Already playing
        if (!this.state.manuallyPaused) {
            return;
        }

        const data = {
            simulationName: simulator.params.simulationName,
            automationMethod: automationMethod,
            events: events,
        };
        await axios
            .post(this.state.serverURL + "/simulate", data, { withCredentials: true })
            .then((response) => {
                this.state.manuallyPaused = false;
                var message = "Finished simulation"
                if(visualise){
                    message = "Finished simulation, visualising"
                }
                this.component.$toast.success(message, { position: "bottom-right", timeout: 7500 })
                this.handleSimulateResponse(response, visualise);
            })
            .catch((e) => { this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })}
            );
    }

    handleSimulateResponse(response, visualise) {
        if (response.data.events == null) {
            console.error("No response stack");
        }
        this.state.simulator.automationMethod = response.data.automationMethod;
        
        if(visualise){
            this.state.pipelineHandler.startAutomation("automatic", response.data.events, false);
        }
        else{
            this.state.pipelineHandler.startAutomateUntilEnd("precalculated", response.data.events)
        }
    }


    async getFutureLoadMetrics() {
        const data = this.state.simulator.getData();

        var returnData = null;

        await axios.post(this.state.serverURL + "/calculateFutureLoads", { data: data }, { withCredentials: true })
        .then((response) => {
            returnData = response.data;
        })
        .catch((e) => {
            console.log(e.response.data.message);
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        })

        return returnData;
    }

    async requestVersion(){
        return await axios.get(this.state.serverURL + "/getVersion", { withCredentials: true });
    }

    async deletePortfolioSettings(saveName){
        const simName = this.state.simulator.params.simulationName;
        
        await axios.post(this.state.serverURL + "/deletePortfolioSettings", {  simName: simName, saveName: saveName }, { withCredentials: true })
        .then((response) => {
            this.component.$toast.success("Succesfully deleted the portfolio settings", { position: "bottom-right", timeout: 7500 });
        })
        .catch((e) => {
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );
    }

    async deleteSimulationSave(saveName){
        const simName = this.state.simulator.params.simulationName;
        
        await axios.post(this.state.serverURL + "/deleteAdminSimulations", {  simName: simName, saveName: saveName }, { withCredentials: true })
        .then((response) => {
            this.component.$toast.success("Succesfully deleted the simulation save", { position: "bottom-right", timeout: 7500 });
        })
        .catch((e) => {
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );
    }

    async checkisAdmin(){
        var isAdmin = false;
        await axios.get(this.state.serverURL + "/users/checkisAdmin", { withCredentials: true })
        .then((response) => {
            isAdmin = response.data.isAdmin;
        })
        .catch((e) => {
        }
        );

        return isAdmin;
    }


    async getAllSimulationSaves(){
        const simName = this.state.simulator.params.simulationName;
        var returnData = null;

        await axios.post(this.state.serverURL + "/getAdminSimulations", {  simName: simName  }, { withCredentials: true })
        .then((response) => {
            // this.component.$toast.success("Succesfully received the portfolio settings", { position: "bottom-right", timeout: 7500 });
            returnData= response.data;
        })
        .catch((e) => {
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );

        return returnData;
    }


    async getAllPortfolioSettings(){
        const simName = this.state.simulator.params.simulationName;
        var returnData = null;
        await axios.post(this.state.serverURL + "/getPortfolioSettings", {  simName: simName  }, { withCredentials: true })
        .then((response) => {
            // this.component.$toast.success("Succesfully received the portfolio settings", { position: "bottom-right", timeout: 7500 });
            returnData= response.data;
        })
        .catch((e) => {
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );

        return returnData;
    }

    async getResults(simName){
        var data = null;
        await axios.post(this.state.serverURL + "/retrieveResults",{simName: simName}, { withCredentials: true })
        .then((response) => {
            data = response.data
        })
        .catch((e) => {
            console.log(e)
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );

        return data;
    }

    async getResultsCount(simName){
        var count = -1;
        await axios.post(this.state.serverURL + "/retrieveResultsCount",{simName: simName}, { withCredentials: true })
        .then((response) => {
            count = response.data.count
        })
        .catch((e) => {
        }
        );

        return count;
    }

    async storeSimulationSave(saveName, update = false){
        const simName = this.state.simulator.params.simulationName;
        const events = this.state.simulationEvents;
        var self = this;
        await axios.post(this.state.serverURL + "/saveAdminSimulations", {  update: update, simName: simName, saveName: saveName, events: events  }, { withCredentials: true })
        .then((response) => {
            this.component.$toast.success("Succesfully saved the portfolio settings", { position: "bottom-right", timeout: 7500 });
        })
        .catch((e) => {
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );
    }

    async storePortfolioSettings(saveName, update = false){

        if(this.state.visualiser == null || this.state.visualiser.projectVisuals == null){
            this.component.$toast.error("No visualiser is loaded", { position: "bottom-right", timeout: 7500 });
            return;
        }

        if(!this.state.simulator.params.allowPortfolioPlanning){
            this.component.$toast.error("Can only store results for simulations with portfolio planning", { position: "bottom-right", timeout: 7500 });
            return;
        }


        var projectOrder = [];
        var startHours = [];

        this.state.visualiser.projectVisuals.forEach((projectVisual) => {
            projectOrder.push(projectVisual.project.projectIndex);
            startHours.push(projectVisual.project.startHour);
        });
        
        const simName = this.state.simulator.params.simulationName;
        var self = this;
        await axios.post(this.state.serverURL + "/savePortfolioSettings", {  update: update, simName: simName, saveName: saveName, startHours: startHours, projectOrder: projectOrder  }, { withCredentials: true })
        .then((response) => {
            this.component.$toast.success("Succesfully saved the portfolio settings", { position: "bottom-right", timeout: 7500 });
        })
        .catch((e) => {
            this.component.$toast.error(e.response.data.message, { position: "bottom-right", timeout: 7500 })
        }
        );
    }

    storePerformanceResults() {
        const finalMetrics = this.state.simulator.performanceTracker.getLatestMetrics();
        var events = this.state.simulator.passedEvents;
        if (!this.state.simulator.params.isManual) {
            events = events.filter(event => event.type != "assignTask");
        }

        //Add the events for portfolio management
        if (this.state.simulator.params.allowPortfolioPlanning) {
            var allZero = true;

            this.state.simulator.projectPool.projects.forEach(project => {

                const event = {
                    projectName: project.name,
                    startHour: project.originalStartHour,
                    disabled: project.originalStartHour > this.state.simulator.params.simulationMaxDurationHours
                }

                if (project.originalStartHour != 0) {
                    allZero = false;
                }
                events.push(event);
            })

            if (allZero) {
                events = [];
            }
        }

        //Only store results if the user did somethnig
        if (events.length == 0) {
            return
        }
        const simName = this.state.simulator.params.simulationName;
        const isManual = this.state.simulator.params.isManual;
        const automationName = this.state.simulator.automationMethod;
        const portfolioManagement = this.state.simulator.params.allowPortfolioPlanning

        axios.post(this.state.serverURL + "/storeResults", { finalMetrics: finalMetrics, events: events, simName: simName, isManual: isManual, automationName: automationName, portfolioManagement: portfolioManagement }, { withCredentials: true })
            .then((response) => {
                this.handleStorePerformanceResponse(response);
            })
            .catch((e) => console.log(e)
            );
    }

    handleStorePerformanceResponse(response) {
    }
}


module.exports = { NetworkHandler };